import type { ScribeNoteSections } from "@/lib/ai-chart-context";

/** Added to the note when an AI draft is applied, so the signed record says how it was produced. */
export const AI_DOCUMENTATION_ATTESTATION =
  "Drafted with AI-assisted documentation from the visit conversation; reviewed and edited by the signing clinician.";

/** Appends the attestation to the plan section (or the last section) of a draft. */
export function withAIAttestation(sections: ScribeNoteSections): ScribeNoteSections {
  const keys = Object.keys(sections);
  if (keys.length === 0) return sections;
  const target = ["plan", "treatment_plan"].find((k) => k in sections) ?? keys[keys.length - 1]!;
  const current = (sections[target] ?? "").trim();
  if (current.includes(AI_DOCUMENTATION_ATTESTATION)) return sections;
  return { ...sections, [target]: current ? `${current}\n\n${AI_DOCUMENTATION_ATTESTATION}` : AI_DOCUMENTATION_ATTESTATION };
}
